import { Routes } from "../../Routes";

type EducationMenuHintContext = {
  pathname: string;
  hasSelectedCourse: boolean;
};

const stripTrailingSlash = (pathname: string): string =>
  pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

/** The welcome page renders on the education root until a course is picked. */
export function shouldShowEducationMenuHint({
  pathname,
  hasSelectedCourse,
}: EducationMenuHintContext): boolean {
  return (
    !hasSelectedCourse && stripTrailingSlash(pathname) === Routes.Educations
  );
}
